import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel, SectionHeading } from './ui/UI';
const features = ['Fast first proof', 'Self-service adoption', 'Disruptive packaging', 'Continuous use', 'Evidence from day one'];
export function MarketGap() {
  return <section className="relative w-full py-32 border-t border-white/5" data-id="element-1075">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1076">
        <SectionLabel number="02" label="The Market" className="mb-8" data-id="element-1077" />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12" data-id="element-1078">
          <div className="lg:col-span-7" data-id="element-1079">
            <SectionHeading size="lg" data-id="element-1080">
              The category is real.{' '}
              <span className="text-white/40" data-id="element-1081">The buying model is broken.</span>
            </SectionHeading>
          </div>
          <div className="lg:col-span-5 lg:pt-4" data-id="element-1082">
            <p className="text-lg text-white/60 leading-relaxed mb-6" data-id="element-1083">
              Security validation is becoming essential, but much of the market
              is still packaged around long evaluations, heavy deployments,
              opaque pricing, and large annual commitments.
            </p>
            <p className="text-lg text-white/60 leading-relaxed" data-id="element-1084">
              Periscan is built differently: start with a Validation Snapshot,
              expand into continuous validation, and pay for what you validate.
            </p>
          </div>
        </div>

        {/* Feature editorial list */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-0 mb-16" data-id="element-1085">
          {features.map((feature, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.04
        }} className="flex items-center gap-6 py-5 border-b border-white/5" data-id="element-1086">
              <span className="font-mono text-xs text-[#1a8fd4]/60" data-id="element-1087">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="text-base text-white font-medium" data-id="element-1088">
                {feature}
              </span>
            </motion.div>)}
        </div>

        <div className="max-w-3xl" data-id="element-1089">
          <p className="text-sm text-white/40 leading-relaxed" data-id="element-1090">
            MarketsandMarkets projects the BAS market to grow from $0.72B in
            2024 to $2.40B by 2029, while Grand View Research estimates exposure
            management at $3.3B in 2024, reaching $10.91B by 2030.
          </p>
        </div>
      </div>
    </section>;
}